import React from 'react';
import { MobileView } from "react-device-detect";
import BtnOrder from "../flipToFibre/button/BtnOrder";
import {useMedia} from "react-use";
import thingsToKnow from "../../../data/speed-boost/speed-boost-things-to-know.json";
import PlainText from "../modules/PlainText";

const MySpeedBoost = () => {
    const isMobile = useMedia("(max-width: 992px)");
    const isTablet = useMedia("(min-width: 768px) and (max-width: 991px)");

    const mobile = <div>
                        <div className="row mb-5 ml-3">
                            <div className="col-xs-3 pr-0 pl-0">
                                 <img src="../images/mini-boost.svg" alt="Speed boost" className="mini-boost"/>
                             </div>
                             <div className="col-xs-9 pl-0 mt-4 pr-0" style={{lineHeight:1}}>
                                 <h3 className="font-x-large col-lg-12 bold m-0">MY SPEED BOOST</h3>
                                 <span className="col-lg-12 color-lime medium-bold font-tiny">Faster speed on the days you need</span>
                             </div>
                        </div>
                        <MobileView>
                            <img src="../images/speed-boost/speed-boost-mobile.png" alt="Speed boost" className="mobile ml-3" />
                        </MobileView>
                        <br/>
                        <div className="col-xs-12">
                            <h1>Faster Business nbn® at the push of a button</h1>
                            <p className="font-medium">With the push of a button you can temporarily boost your Exetel Business nbn® speed with <span className="color-lime bold">5 FREE Speed Upgrade Days</span> each and every month. Unused days rollover into your <span className="color-lime bold">My Speed Boost Bank™</span> to a max of 30 days. Purchase additional Speed Upgrade Days for just $2/day. </p>
                        </div>
                        <section className="feature-section">
                            <div className="font-medium">
                                <ul className="pl-4">
                                    <li>Up to double your internet speed for 24 hours</li>
                                    <li>5 FREE Speed Upgrade Days a month</li>
                                    <li>Bank up to 30 unused Speed Upgrade Days for later</li>
                                    <li>Additional Speed Upgrade Days for only $2 a day</li>
                                </ul>
                            </div>
                            <br/>
                            <BtnOrder text={"View nbn®  plans"} class={"col-xs-6"} radius={"5px"} backgroundColor={"silver"} fontSize={"font-medium bold"} link={"/small-business/nbn"}/>
                            <BtnOrder text={"Boost in My Exetel"} class={"col-xs-6 pr-4"} radius={"5px"} fontSize={"font-medium bold"} onClick={ () => window.open('https://my.exetel.com.au/dashboard', '_blank', 'noopener,noreferrer')}/>
                        </section>
                    </div>;

    const desktop = <div className="row">
                        <div className="col-lg-6 col-sm-7">
                            <h1>Faster Business nbn® at the push of a button</h1>
                            <br/>
                            <p className={`${isTablet ? 'font-medium': 'font-large'}`}>With the push of a button you can temporarily boost your Exetel Business nbn® speed with <span className="color-lime bold">5 FREE Speed Upgrade Days</span> each and every month. Unused days rollover into your <span className="color-lime bold">My Speed Boost Bank™</span> to a max of 30 days. Purchase additional Speed Upgrade Days for just $2/day. </p>
                            <section className="feature-section">
                                <div className={`${isTablet ? 'font-medium': 'font-large'}`}>
                                    <ul className="p-0">
                                        <li>Up to double your internet speed for 24 hours</li>
                                        <li>5 FREE Speed Upgrade Days a month</li>
                                        <li>Bank up to 30 unused Speed Upgrade Days for later</li>
                                        <li>Additional Speed Upgrade Days for only $2 a day</li>
                                    </ul>
                                </div>
                            </section>
                            <br/>
                            <section className={`row ${isTablet ? 'p-0': ''}`}>
                               <BtnOrder text={"View nbn®  plans"} class={"col-lg-5 col-sm-6 2 pr-lg-3"} radius={"5px"} backgroundColor={"silver"} fontSize={"font-medium bold"} link={"/small-business/nbn"}/>
                                <BtnOrder text={"Boost in My Exetel"} class={"col-lg-5 col-sm-6 pr-sm-0 pl-lg-3"} radius={"5px"} fontSize={"font-medium bold"} onClick={ () => window.open('https://my.exetel.com.au/dashboard', '_blank', 'noopener,noreferrer')}/>
                            </section>
                        </div>
                        <div className="col-lg-6 col-sm-5 p-sm-0">
                            <div className="row mb-5 col-lg-offset-1">
                                <div className="col-lg-3 col-sm-4 pr-0 pl-0 mini-boost">
                                    <img src="../images/mini-boost.svg" alt="Speed boost"/>
                                </div>
                                <div className="col-lg-7 col-sm-8 pl-0 mt-lg-4 mt-sm-4 pt-sm-1 pr-0 my-speed-boost-title">
                                    <h3 className={`col-lg-12 bold m-0 pl-sm-2 pr-sm-0 ${!isTablet ? 'font-heading-medium': 'font-x-large'}`}>MY SPEED BOOST</h3>
                                    <span className={`col-lg-12 color-lime medium-bold pl-sm-2 pr-sm-1 ${!isTablet ? 'font-medium': 'font-tiny'}`}>Faster speed on the days you need</span>
                                </div>
                            </div>
                            {
                                isTablet ? <img src="../images/speed-boost/speed-boost-tablet.png" className="col-sm-offset-1 speed-boost-image" alt="Speed boost" /> : <img src="../images/speed-boost/speed-boost-desktop.png" alt="Speed boost" />
                            }
                        </div>
                    </div>

    return (
        <div className="speed-boost">
            <article className="container p-0">
                { isMobile ? !isTablet ? mobile: desktop: desktop }
            </article>
            <div className="things-to-know mt-5 pb-5">
               <div className="container">
                   <h1 className="text-center m-0">Things you need to know</h1>
                   {
                       thingsToKnow.needToKnow.map((item, key) => {
                           return (
                               <PlainText data={item} excludeTitle={true} key={key} />
                           )
                       })
                   }
               </div>
            </div>
        </div>
    )
}

export default MySpeedBoost;


// WEBPACK FOOTER //
// ./resources/assets/js/pages/MySpeedBoost.js